// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2iQRp","content":"LoadingAlert_content__1H4MV"};